import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  eventParticipants,
  registryConfiguration,
} from "../../../../../data-store/actions/registry-actions";
import TableBody from "@material-ui/core/TableBody";

import IncomeRow from "./IncomeRow";
import {
  filtraPorEstatus,
  coincideFiltros,
  ordenarInscritos,
} from "./incomeTableLogic";
import { calcularModalidadesConRangoDorsalCambiado } from "../participantValidationLogic";

export default function IncomeTableCont(props) {
  const {
    camposAdicionales,
    productosAdicionales,
    filter,
    quantity,
    ordenarPor,
    direccionOrden,
    filtrosColumnas,
  } = props;

  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventParticipants = useSelector(
    (state) => state.registry.eventParticipants
  );
  const registryAutorizedUsers = useSelector(
    (state) => state.registry.registryAutorizedUsers
  );
  const eventSubEventsRegistry = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  // Mismo criterio de shadowing que ya tiene arriba "eventParticipants"
  // (importado como action creator, pero acá hace falta el dato de Redux).
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );

  let { EventoIndex } = useParams();
  console.log("eventDetail", eventDetail);
  if ("evento_" + eventDetail.iDEvento !== EventoIndex) {
    return (
      <Grid container direction="row" alignItems="flex-start">
        <Grid item xs={12}>
          <Typography gutterBottom variant={"h2"} component="h2">
            Error Recarga la web
          </Typography>
        </Grid>
      </Grid>
    );
  }

  var perfilUsuarioEvento = registryAutorizedUsers[userID].perfil;

  // Se calcula sobre TODOS los inscritos del evento (no solo los
  // visibles/filtrados) para detectar, por modalidad, si casi todos los
  // dorsales quedaron fuera de rango — típico de un cambio de rango de
  // folios cerca del evento, no de errores individuales de asignación.
  const modalidadesConRangoDorsalCambiado = calcularModalidadesConRangoDorsalCambiado(
    eventParticipants,
    eventSubEventsRegistry
  );

  // Primero se arma la lista de inscritos realmente visibles (permiso +
  // estatus + filtros por columna) y RECIÉN sobre esa lista se ordena y se
  // aplica la ventana de "quantity" — antes la ventana se calculaba sobre
  // el total sin filtrar, así que "Mostrar registros anteriores" podía no
  // mostrar nada aunque hubiera resultados filtrados más atrás.
  const contexto = {
    eventSubEventsRegistry,
    registryAutorizedUsers,
    eventDetail,
    registryConfiguration,
    modalidadesConRangoDorsalCambiado,
    camposAdicionalesArray: camposAdicionales.camposAdicionalesModalidad,
    productosAdicionalesArray:
      productosAdicionales.productosAdicionalesModalidadTitulo,
  };

  var entradasVisibles = [];
  for (var i in eventParticipants) {
    var puedeVerla =
      perfilUsuarioEvento == "master" ||
      perfilUsuarioEvento == "MasterCliente" ||
      perfilUsuarioEvento == "MasterOrganizador" ||
      userID == eventParticipants[i].usuarioRegistra;
    if (
      puedeVerla &&
      filtraPorEstatus(eventParticipants[i], filter) &&
      coincideFiltros(eventParticipants[i], filtrosColumnas || {}, contexto)
    ) {
      entradasVisibles.push([i, eventParticipants[i]]);
    }
  }

  // La ventana de "quantity" siempre se basa en qué tan RECIENTE es el
  // registro, sin importar por qué columna se esté ordenando para
  // mostrar — así "mostrar los últimos 100" siempre significa los 100
  // registros más nuevos, y no "los primeros 100 en el orden elegido"
  // (ej. alfabético) si el admin cambia el orden de visualización.
  const porRecencia = ordenarInscritos(entradasVisibles, "fechaRegistro", "desc", contexto);
  const ventana = porRecencia.slice(0, quantity);
  const entradasOrdenadas = ordenarInscritos(ventana, ordenarPor, direccionOrden, contexto);

  var dataTable = entradasOrdenadas
    .map(([key, inscritoData]) => (
      <IncomeRow
        key={key}
        inscritoData={inscritoData}
        inscritoKey={key}
        camposAdicionales={camposAdicionales}
        productosAdicionales={productosAdicionales}
        filter={filter}
        modalidadesConRangoDorsalCambiado={modalidadesConRangoDorsalCambiado}
      />
    ));

  return <TableBody>{dataTable}</TableBody>;
}
